import type { ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import type { KittTransitionProps } from '../propTypes';
import styles from './styles.module.css';

const classNames = {
  appear: styles.FadeInEnter,
  appearActive: styles.FadeInEnterActive,
  enter: styles.FadeInEnter,
  enterActive: styles.FadeInEnterActive,
  exit: styles.FadeInExit,
  exitActive: styles.FadeInExitActive,
};

export function FadeIn({
  appear,
  children,
  visible,
  onEnter,
  onExit,
  onEntered,
  onExited,
}: KittTransitionProps): ReactNode {
  return (
    <CSSTransition
      unmountOnExit
      appear={appear}
      classNames={classNames}
      in={visible}
      timeout={250}
      onEnter={onEnter}
      onExit={onExit}
      onEntered={onEntered}
      onExited={onExited}
    >
      {children()}
    </CSSTransition>
  );
}
